<template>
  <div>
    <div class="flex flex-col">
      <div class="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-6 gap-4 mb-6">
        <div :class="['bg-white rounded-lg shadow-md hover:shadow-lg transition-shadow duration-200 p-4 border-l-4', countSRT334 > 0 ? 'border-green-500' : 'border-blue-400']">
          <div class="text-sm font-medium text-gray-600 mb-1">SRT334</div>
          <div :class="['text-3xl font-bold', countSRT334 > 0 ? 'text-green-600' : 'text-blue-500']">{{ countSRT334 }}</div>
        </div>
        <div :class="['bg-white rounded-lg shadow-md hover:shadow-lg transition-shadow duration-200 p-4 border-l-4', countSRT405 > 0 ? 'border-green-500' : 'border-blue-400']">
          <div class="text-sm font-medium text-gray-600 mb-1">SRT405</div>
          <div :class="['text-3xl font-bold', countSRT405 > 0 ? 'text-green-600' : 'text-blue-500']">{{ countSRT405 }}</div>
        </div>
        <div :class="['bg-white rounded-lg shadow-md hover:shadow-lg transition-shadow duration-200 p-4 border-l-4', countSRT405i > 0 ? 'border-green-500' : 'border-blue-400']">
          <div class="text-sm font-medium text-gray-600 mb-1">SRT405i</div>
          <div :class="['text-3xl font-bold', countSRT405i > 0 ? 'text-green-600' : 'text-blue-500']">{{ countSRT405i }}</div>
        </div>
        <div :class="['bg-white rounded-lg shadow-md hover:shadow-lg transition-shadow duration-200 p-4 border-l-4', countSRT406 > 0 ? 'border-green-500' : 'border-blue-400']">
          <div class="text-sm font-medium text-gray-600 mb-1">SRT406</div>
          <div :class="['text-3xl font-bold', countSRT406 > 0 ? 'text-green-600' : 'text-blue-500']">{{ countSRT406 }}</div>
        </div>
        <div :class="['bg-white rounded-lg shadow-md hover:shadow-lg transition-shadow duration-200 p-4 border-l-4', countSRT406i > 0 ? 'border-green-500' : 'border-blue-400']">
          <div class="text-sm font-medium text-gray-600 mb-1">SRT406i</div>
          <div :class="['text-3xl font-bold', countSRT406i > 0 ? 'text-green-600' : 'text-blue-500']">{{ countSRT406i }}</div>
        </div>
        <div :class="['bg-white rounded-lg shadow-md hover:shadow-lg transition-shadow duration-200 p-4 border-l-4', countTwigNeo > 0 ? 'border-green-500' : 'border-blue-400']">
          <div class="text-sm font-medium text-gray-600 mb-1">TWIG Neo</div>
          <div :class="['text-3xl font-bold', countTwigNeo > 0 ? 'text-green-600' : 'text-blue-500']">{{ countTwigNeo }}</div>
        </div>
        <div :class="['bg-white rounded-lg shadow-md hover:shadow-lg transition-shadow duration-200 p-4 border-l-4', countTwigNeoSrd > 0 ? 'border-green-500' : 'border-blue-400']">
          <div class="text-sm font-medium text-gray-600 mb-1">TWIG Neo SRD</div>
          <div :class="['text-3xl font-bold', countTwigNeoSrd > 0 ? 'text-green-600' : 'text-blue-500']">{{ countTwigNeoSrd }}</div>
        </div>
        <div :class="['bg-white rounded-lg shadow-md hover:shadow-lg transition-shadow duration-200 p-4 border-l-4', countTwigNeoMd > 0 ? 'border-green-500' : 'border-blue-400']">
          <div class="text-sm font-medium text-gray-600 mb-1">TWIG Neo MD</div>
          <div :class="['text-3xl font-bold', countTwigNeoMd > 0 ? 'text-green-600' : 'text-blue-500']">{{ countTwigNeoMd }}</div>
        </div>
        <div :class="['bg-white rounded-lg shadow-md hover:shadow-lg transition-shadow duration-200 p-4 border-l-4', countTwigNeoSrdMd > 0 ? 'border-green-500' : 'border-blue-400']">
          <div class="text-sm font-medium text-gray-600 mb-1">TWIG Neo SRD MD</div>
          <div :class="['text-3xl font-bold', countTwigNeoSrdMd > 0 ? 'text-green-600' : 'text-blue-500']">{{ countTwigNeoSrdMd }}</div>
        </div>
        <div :class="['bg-white rounded-lg shadow-md hover:shadow-lg transition-shadow duration-200 p-4 border-l-4', countTwigOne > 0 ? 'border-green-500' : 'border-blue-400']">
          <div class="text-sm font-medium text-gray-600 mb-1">TWIG One</div>
          <div :class="['text-3xl font-bold', countTwigOne > 0 ? 'text-green-600' : 'text-blue-500']">{{ countTwigOne }}</div>
        </div>
        <div :class="['bg-white rounded-lg shadow-md hover:shadow-lg transition-shadow duration-200 p-4 border-l-4', countTwigOneSrd > 0 ? 'border-green-500' : 'border-blue-400']">
          <div class="text-sm font-medium text-gray-600 mb-1">TWIG One SRD</div>
          <div :class="['text-3xl font-bold', countTwigOneSrd > 0 ? 'text-green-600' : 'text-blue-500']">{{ countTwigOneSrd }}</div>
        </div>
        <div :class="['bg-white rounded-lg shadow-md hover:shadow-lg transition-shadow duration-200 p-4 border-l-4', countTwigOneEx > 0 ? 'border-green-500' : 'border-blue-400']">
          <div class="text-sm font-medium text-gray-600 mb-1">TWIG One EX</div>
          <div :class="['text-3xl font-bold', countTwigOneEx > 0 ? 'text-green-600' : 'text-blue-500']">{{ countTwigOneEx }}</div>
        </div>
        <div :class="['bg-white rounded-lg shadow-md hover:shadow-lg transition-shadow duration-200 p-4 border-l-4', countTwigButton > 0 ? 'border-green-500' : 'border-blue-400']">
          <div class="text-sm font-medium text-gray-600 mb-1">TWIG Button</div>
          <div :class="['text-3xl font-bold', countTwigButton > 0 ? 'text-green-600' : 'text-blue-500']">{{ countTwigButton }}</div>
        </div>
        <div :class="['bg-white rounded-lg shadow-md hover:shadow-lg transition-shadow duration-200 p-4 border-l-4', countTwigEon > 0 ? 'border-green-500' : 'border-blue-400']">
          <div class="text-sm font-medium text-gray-600 mb-1">TWIG Eon</div>
          <div :class="['text-3xl font-bold', countTwigEon > 0 ? 'text-green-600' : 'text-blue-500']">{{ countTwigEon }}</div>
        </div>
        <div :class="['bg-white rounded-lg shadow-md hover:shadow-lg transition-shadow duration-200 p-4 border-l-4', countTwigBeacon > 0 ? 'border-green-500' : 'border-blue-400']">
          <div class="text-sm font-medium text-gray-600 mb-1">TWIG Beacon</div>
          <div :class="['text-3xl font-bold', countTwigBeacon > 0 ? 'text-green-600' : 'text-blue-500']">{{ countTwigBeacon }}</div>
        </div>
        <div :class="['bg-white rounded-lg shadow-md hover:shadow-lg transition-shadow duration-200 p-4 border-l-4', countEmeritWg100 > 0 ? 'border-green-500' : 'border-blue-400']">
          <div class="text-sm font-medium text-gray-600 mb-1">EMERIT WG100</div>
          <div :class="['text-3xl font-bold', countEmeritWg100 > 0 ? 'text-green-600' : 'text-blue-500']">{{ countEmeritWg100 }}</div>
        </div>
        <div :class="['bg-white rounded-lg shadow-md hover:shadow-lg transition-shadow duration-200 p-4 border-l-4', countEmeritEb10 > 0 ? 'border-green-500' : 'border-blue-400']">
          <div class="text-sm font-medium text-gray-600 mb-1">EMERIT E-B10</div>
          <div :class="['text-3xl font-bold', countEmeritEb10 > 0 ? 'text-green-600' : 'text-blue-500']">{{ countEmeritEb10 }}</div>
        </div>
        <div :class="['bg-white rounded-lg shadow-md hover:shadow-lg transition-shadow duration-200 p-4 border-l-4', countEmeritWg200 > 0 ? 'border-green-500' : 'border-blue-400']">
          <div class="text-sm font-medium text-gray-600 mb-1">EMERIT WG200</div>
          <div :class="['text-3xl font-bold', countEmeritWg200 > 0 ? 'text-green-600' : 'text-blue-500']">{{ countEmeritWg200 }}</div>
        </div>
        <div :class="['bg-white rounded-lg shadow-md hover:shadow-lg transition-shadow duration-200 p-4 border-l-4', countEmeritWg200G > 0 ? 'border-green-500' : 'border-blue-400']">
          <div class="text-sm font-medium text-gray-600 mb-1">EMERIT WG200-G</div>
          <div :class="['text-3xl font-bold', countEmeritWg200G > 0 ? 'text-green-600' : 'text-blue-500']">{{ countEmeritWg200G }}</div>
        </div>
        <div :class="['bg-white rounded-lg shadow-md hover:shadow-lg transition-shadow duration-200 p-4 border-l-4', countTeltonikaFMC003 > 0 ? 'border-green-500' : 'border-blue-400']">
          <div class="text-sm font-medium text-gray-600 mb-1">TELTONIKA FMC003</div>
          <div :class="['text-3xl font-bold', countTeltonikaFMC003 > 0 ? 'text-green-600' : 'text-blue-500']">{{ countTeltonikaFMC003 }}</div>
        </div>
        <div :class="['bg-white rounded-lg shadow-md hover:shadow-lg transition-shadow duration-200 p-4 border-l-4', countSRT430 > 0 ? 'border-green-500' : 'border-blue-400']">
          <div class="text-sm font-medium text-gray-600 mb-1">SRT430</div>
          <div :class="['text-3xl font-bold', countSRT430 > 0 ? 'text-green-600' : 'text-blue-500']">{{ countSRT430 }}</div>
        </div>
        <div :class="['bg-white rounded-lg shadow-md hover:shadow-lg transition-shadow duration-200 p-4 border-l-4', countSRT341 > 0 ? 'border-green-500' : 'border-blue-400']">
          <div class="text-sm font-medium text-gray-600 mb-1">SRT341</div>
          <div :class="['text-3xl font-bold', countSRT341 > 0 ? 'text-green-600' : 'text-blue-500']">{{ countSRT341 }}</div>
        </div>
      </div>
      <div class="w-full">
        <vue-good-table
          ref="orderDocumentTable"
          mode="remote"
          styleClass="vgt-table striped bordered condensed whitespace-nowrap"
          row-style-class="text-sm"
          :columns="columns"
          :rows="orders"
          :totalRows="totalRecords"
          :search-options="{
            enabled: true,
            placeholder: 'Sök',
          }"
          :pagination-options="{
            enabled: true,
            perPage: 1000,
            perPageDropdown: [500, 1000, 1500],
            dropdownAllowAll: true,
          }"
          @on-page-change="onPageChange"
          @on-per-page-change="onPerPageChange"
          @on-sort-change="onSortChange"
          @on-column-filter="onColumnFilter"
          @on-search="onSearch"
          :line-numbers="true"
        >
          <div slot="table-actions">
            <button class="btn-green-outline mx-1" @click="$modal.show('modal-add-order')">
              {{ $t('stock_table.add_product') }}
              <BaseIcon icon="plus" class="ml-1" />
            </button>
            <button class="btn-green-outline mx-1" @click="importOrders()">
              <label class="cursor-pointer font-sans">
                {{ $t("import") }}
                <BaseIcon icon="cloud-upload-alt" class="ml-1" />
                <input type="file" accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" ref="importOrderFile" @change="importOrders()" class="hidden" />
              </label>
            </button>
            <button class="btn-blue-outline mx-1" @click="exportOrders()">
              {{ $t("export") }}
              <BaseIcon icon="file-excel" class="ml-1" />
            </button>
          </div>
          <template slot="table-row" slot-scope="props">
            <span v-if="props.column.field == 'delete'">
              <button class="btn-red-outline" @click.prevent="deleteOrderPrompt(props.row)">
                <BaseIcon icon="trash" class="" />
              </button>
            </span>
            <span v-else>
              {{ props.formattedRow[props.column.field] }}
            </span>
          </template>
        </vue-good-table>
      </div>
    </div>

    <modal name="modal-add-order" class="modal-inner" transition="pop-out" :width="500" :focus-trap="true" :min-height="200" height="auto" :scrollable="true" @before-close="resetAddOrderForm()">
      <span class="close-button" @click="$modal.hide('modal-add-order')"><BaseIcon icon="times-circle" class="text-white"/></span>
      <div class="modal-header text-lg px-6">
        <span class="text-white font-serif">{{ $t('stock_table.add_product') }}</span>
      </div>
      <div class="modal-body">
        <div class="flex flex-col gap-4 p-2">
          <div>
            <label class="block text-sm font-medium text-gray-600 mb-1">{{ $t('stock_table.product') }}</label>
            <select v-model="newOrder.type" class="w-full bg-gray-100 rounded text-sm text-gray-900 focus:outline-none border-b border-gray-300 px-3 py-2">
              <option value="" disabled>{{ $t('stock_table.select_product') }}</option>
              <option v-for="device in devices" :key="device" :value="device">{{ device }}</option>
            </select>
          </div>
          <div>
            <label class="block text-sm font-medium text-gray-600 mb-1">{{ $t('stock_table.serial_number') }}</label>
            <input v-model="newOrder.modelnumber" type="text" class="w-full bg-gray-100 rounded text-sm text-gray-900 focus:outline-none border-b border-gray-300 px-3 py-2" />
          </div>
          <div>
            <label class="block text-sm font-medium text-gray-600 mb-1">{{ $t('stock_table.imei') }}</label>
            <input v-model="newOrder.imei_number" type="text" class="w-full bg-gray-100 rounded text-sm text-gray-900 focus:outline-none border-b border-gray-300 px-3 py-2" />
          </div>
          <div>
            <label class="block text-sm font-medium text-gray-600 mb-1">{{ $t('stock_table.programmed') }}</label>
            <input v-model="newOrder.program" type="text" class="w-full bg-gray-100 rounded text-sm text-gray-900 focus:outline-none border-b border-gray-300 px-3 py-2" />
          </div>
          <div>
            <label class="block text-sm font-medium text-gray-600 mb-1">{{ $t('stock_table.password') }}</label>
            <input v-model="newOrder.password" type="text" class="w-full bg-gray-100 rounded text-sm text-gray-900 focus:outline-none border-b border-gray-300 px-3 py-2" />
          </div>
        </div>
        <div class="mt-4 flex justify-end gap-2 p-2">
          <button @click="$modal.hide('modal-add-order')" class="btn-secondary-outline text-sm">{{ $t('modals.cancel') }}</button>
          <button @click="submitNewOrder()" class="btn-green text-sm" :disabled="!newOrder.type">{{ $t('user_actions.save') }} <BaseIcon icon="save" class="ml-1" /></button>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import XLSX from "xlsx";

export default {
  title() {
    return this.$t('page_titles.delivery_document');
  },
  data() {
    return {
      user: this.$store.state.user,
      orders: [],
      devices: ["SRT334", "SRT405", "SRT405i", "SRT406", "SRT406i", "SRT430", "SRT341", "TWIG Neo", "TWIG Neo SRD", "TWIG Neo MD", "TWIG Neo SRD MD", "TWIG One", "TWIG One SRD", "TWIG One EX", "TWIG Button", "TWIG Eon", "TWIG Beacon", "EMERIT WG100", "EMERIT E-B10", "EMERIT WG200", "EMERIT WG200-G", "TELTONIKA FMC003"],
      countSRT334: 0,
      countSRT405: 0,
      countSRT405i: 0,
      countSRT406: 0,
      countSRT406i: 0,
      countSRT430: 0,
      countSRT341: 0,
      countTwigNeo: 0,
      countTwigNeoSrd: 0,
      countTwigNeoMd: 0,
      countTwigNeoSrdMd: 0,
      countTwigOne: 0,
      countTwigOneSrd: 0,
      countTwigOneEx: 0,
      countTwigButton: 0,
      countTwigEon: 0,
      countTwigBeacon: 0,
      countEmeritWg100: 0,
      countEmeritEb10: 0,
      countEmeritWg200: 0,
      countEmeritWg200G: 0,
      countTeltonikaFMC003: 0,
      totalRecords: 0,
      serverParams: {
        page: 1,
        perPage: 1000,
        search: '',
        sortField: 'createdAt',
        sortType: 'desc',
        columnFilters: {},
      },
      isLoading: false,
      searchTimer: null,
      newOrder: {
        type: '',
        modelnumber: '',
        imei_number: '',
        program: '',
        password: '',
      },
    };
  },

  methods: {
    updateParams(newProps) {
      this.serverParams = Object.assign({}, this.serverParams, newProps);
    },
    onPageChange(params) {
      this.updateParams({ page: params.currentPage });
      this.loadOrders();
    },
    onPerPageChange(params) {
      this.updateParams({ perPage: params.currentPerPage, page: 1 });
      this.loadOrders();
    },
    onSortChange(params) {
      if (!params[0]) return;
      this.updateParams({ sortField: params[0].field, sortType: params[0].type, page: 1 });
      this.loadOrders();
    },
    onColumnFilter(params) {
      this.updateParams({ columnFilters: params.columnFilters, page: 1 });
      this.loadOrders();
    },
    onSearch(params) {
      clearTimeout(this.searchTimer);
      this.searchTimer = setTimeout(() => {
        this.updateParams({ search: params.searchTerm, page: 1 });
        this.loadOrders();
      }, 400);
    },
    loadOrders() {
      const params = {
        page: this.serverParams.page,
        perPage: this.serverParams.perPage,
        search: this.serverParams.search,
        sortField: this.serverParams.sortField,
        sortType: this.serverParams.sortType,
      };
      if (this.serverParams.columnFilters.type) {
        params.filterType = this.serverParams.columnFilters.type;
      }
      this.axios
        .get(`${process.env.VUE_APP_SERVER_URL}/orders`, { params })
        .then((response) => {
          this.orders = response.data.orders;
          this.totalRecords = response.data.totalRecords;
        })
        .catch((error) => {
          this.handleError(error);
        });
    },
    getStockCounts() {
      this.axios
        .get(`${process.env.VUE_APP_SERVER_URL}/orders/stock-counts`)
        .then((response) => {
          const counts = response.data.stockCounts;
          this.countSRT334 = counts['SRT334'] || 0;
          this.countSRT405 = counts['SRT405'] || 0;
          this.countSRT405i = counts['SRT405i'] || 0;
          this.countSRT406 = counts['SRT406'] || 0;
          this.countSRT406i = counts['SRT406i'] || 0;
          this.countSRT430 = counts['SRT430'] || 0;
          this.countSRT341 = counts['SRT341'] || 0;
          this.countTwigNeo = counts['TWIG Neo'] || 0;
          this.countTwigNeoSrd = counts['TWIG Neo SRD'] || 0;
          this.countTwigNeoMd = counts['TWIG Neo MD'] || 0;
          this.countTwigNeoSrdMd = counts['TWIG Neo SRD MD'] || 0;
          this.countTwigOne = counts['TWIG One'] || 0;
          this.countTwigOneSrd = counts['TWIG One SRD'] || 0;
          this.countTwigOneEx = counts['TWIG One EX'] || 0;
          this.countTwigButton = counts['TWIG Button'] || 0;
          this.countTwigEon = counts['TWIG Eon'] || 0;
          this.countTwigBeacon = counts['TWIG Beacon'] || 0;
          this.countEmeritWg100 = counts['EMERIT WG100'] || 0;
          this.countEmeritEb10 = counts['EMERIT E-B10'] || 0;
          this.countEmeritWg200 = counts['EMERIT WG200'] || 0;
          this.countEmeritWg200G = counts['EMERIT WG200-G'] || 0;
          this.countTeltonikaFMC003 = counts['TELTONIKA FMC003'] || 0;
        })
        .catch((error) => {
          this.handleError(error);
        });
    },

    resetAddOrderForm() {
      this.newOrder = { type: '', modelnumber: '', imei_number: '', program: '', password: '' };
    },

    async submitNewOrder() {
      try {
        this.isLoading = true;
        await this.axios.post(`${process.env.VUE_APP_SERVER_URL}/order/bulk`, [this.newOrder]);
        this.loadOrders();
        this.getStockCounts();
        this.$modal.hide('modal-add-order');
        this.handleSuccess(this.$t('stock_table.product_added'));
      } catch (error) {
        this.handleError(error);
      } finally {
        this.isLoading = false;
      }
    },

    normalizeProgram(val) {
      if (!val) return val;
      const v = val.trim();
      const lower = v.toLowerCase();
      if (lower === 'std' || lower.includes('default') || lower.includes('securcloud')) {
        return 'Securcloud Default';
      }
      return v;
    },

    detectImportFormat(headers) {
      const normalized = headers.map(h => (h || '').toString().trim().toLowerCase());
      if (normalized.includes('produkt')) return 'srt_template';
      if (normalized.includes('product model')) return 'securdia_info';
      if (normalized.includes('product name')) return 'manufacturer_delivery';
      if (normalized.includes('imei nummer') || normalized.includes('serie nummer')) return 'inleverans_twig';
      return null;
    },

    resolveDeviceType(productModel) {
      const model = (productModel || '').toString().trim();
      if (!model) return '';
      if (this.devices.includes(model)) return model;

      const upper = model.toUpperCase();

      // SRT variant mapping: 030G suffix = "i" variant, 020G suffix = standard
      if (upper.includes('030G')) {
        const base = model.replace(/030G.*$/i, 'i');
        if (this.devices.includes(base)) return base;
      }
      if (upper.includes('020G')) {
        const base = model.replace(/020G.*$/i, '');
        if (this.devices.includes(base)) return base;
      }

      // Sort devices longest-first for best match precision
      const sorted = [...this.devices].sort((a, b) => b.length - a.length);

      // Prefix match: product name starts with a known device (e.g. SRT4300101A06 → SRT430)
      for (const device of sorted) {
        if (upper.startsWith(device.toUpperCase())) return device;
      }

      // Contains match: product name contains a known device name
      for (const device of sorted) {
        if (upper.includes(device.toUpperCase())) return device;
      }

      // Model-part match: for multi-word devices (TELTONIKA FMC003, EMERIT WG100, etc.)
      // check if the product starts with any identifying part (3+ chars)
      for (const device of sorted) {
        const parts = device.split(' ');
        if (parts.length < 2) continue;
        for (const part of parts) {
          if (part.length >= 3 && upper.startsWith(part.toUpperCase())) return device;
        }
      }

      return model;
    },

    parseSrtTemplate(ordersArr) {
      return ordersArr.map((el) => {
        let type = '';
        if (el['Produkt'] && this.devices.includes(el['Produkt'].toString().trim())) {
          type = el['Produkt'].toString().trim();
        }
        return {
          type,
          modelnumber: el['Serienummer'] ? el['Serienummer'].toString().trim() : '',
          imei_number: el['Imei-nummer'] ? el['Imei-nummer'].toString().trim() : (el['IMEI'] ? el['IMEI'].toString().trim() : ''),
          program: this.normalizeProgram(el['Programmerad']?.toString().trim()) || 'Securcloud Default',
        };
      });
    },

    parseSecurdiaInfoOrder(ordersArr) {
      return ordersArr.map((el) => ({
        type: el['Product model'] ? this.resolveDeviceType(el['Product model']) : '',
        modelnumber: el['Serial No'] ? el['Serial No'].toString().trim() : '',
        imei_number: el['IMEI'] ? el['IMEI'].toString().trim() : '',
        program: this.normalizeProgram(el['Setting']?.toString().trim()) || '',
      }));
    },

    parseInleveransTwig(ordersArr) {
      return ordersArr
        .filter((el) => el['Model'] && el['Model'].toString().trim())
        .map((el) => {
          const model = el['Model'].toString().trim();
          return {
            type: `TWIG ${model}`,
            modelnumber: el['Serie nummer'] ? el['Serie nummer'].toString().trim() : '',
            imei_number: el['IMEI nummer'] ? el['IMEI nummer'].toString().trim() : '',
            program: 'Securcloud Default',
            password: el['Password'] ? el['Password'].toString().trim() : '',
          };
        });
    },

    parseManufacturerDelivery(ordersArr) {
      return ordersArr
        .filter((el) => el['IMEI'] && el['IMEI'].toString().trim())
        .map((el) => ({
          type: el['Product name'] ? this.resolveDeviceType(el['Product name']) : '',
          modelnumber: el['Series'] ? el['Series'].toString().trim() : '',
          imei_number: el['IMEI'].toString().trim(),
          program: this.normalizeProgram(el['Settings']?.toString().trim()) || '',
        }));
    },

    importOrders() {
      if (this.$refs.importOrderFile.files.length > 0) {
        let file = this.$refs.importOrderFile.files[0];
        let reader = new FileReader();

        reader.onload = (evt) => {
          let workbook = XLSX.read(evt.target.result, { type: "binary" });
          let worksheet = workbook.Sheets[workbook.SheetNames[0]];
          let ordersArr = XLSX.utils.sheet_to_row_object_array(worksheet);

          if (ordersArr.length === 0) {
            this.handleError({ message: 'No data found in file' });
            return;
          }

          const headers = Object.keys(ordersArr[0]);
          const format = this.detectImportFormat(headers);
          let newOrders;

          if (format === 'srt_template') {
            newOrders = this.parseSrtTemplate(ordersArr);
          } else if (format === 'securdia_info') {
            newOrders = this.parseSecurdiaInfoOrder(ordersArr);
          } else if (format === 'inleverans_twig') {
            newOrders = this.parseInleveransTwig(ordersArr);
          } else if (format === 'manufacturer_delivery') {
            newOrders = this.parseManufacturerDelivery(ordersArr);
          } else {
            this.handleError({ message: 'Unknown file format. Supported formats: SRT Template (Produkt), Securdia Info Order (Product model), Manufacturer Delivery (Product name), Inleverans Twig (IMEI nummer).' });
            this.$refs.importOrderFile.value = null;
            return;
          }

          // SEC-318: warn before importing rows that have no product type
          const emptyTypeCount = this.countEmptyProductTypes(newOrders);
          if (emptyTypeCount > 0) {
            this.confirmImportWithEmptyTypes(newOrders, emptyTypeCount);
            return;
          }

          this.submitImportedOrders(newOrders);
        };

        reader.onerror = (evt) => {
          console.error(evt);
        };

        reader.readAsBinaryString(file);
      }
    },

    countEmptyProductTypes(newOrders) {
      return newOrders.filter((order) => !order.type || !order.type.toString().trim()).length;
    },

    // SEC-318: the product type column is empty for some rows, let the user cancel or continue
    confirmImportWithEmptyTypes(newOrders, emptyTypeCount) {
      this.$modal.show("dialog", {
        title: `<span class="text-red-500">${this.$t('modals.import_empty_product_type.title')}</span>`,
        text: `<p style="text-align: center;">${this.$t('modals.import_empty_product_type.text', { count: emptyTypeCount, total: newOrders.length })}</p>`,
        buttons: [
          {
            title: `<div class="bg-success-500 text-white text-sm font-sans py-2">${this.$t('modals.cancel')}</div>`,
            handler: () => {
              // cancel: import nothing and clear the chosen file
              this.$modal.hide("dialog");
              this.$refs.importOrderFile.value = null;
            },
          },
          {
            title: `<div class="bg-red-500 text-white text-sm font-sans py-2">${this.$t('modals.import_empty_product_type.continue')}</div>`,
            handler: () => {
              // continue: import the file as today, empty product types included
              this.$modal.hide("dialog");
              this.submitImportedOrders(newOrders);
            },
          },
        ],
      });
    },

    // SEC-318: send the imported rows to the server (moved out of importOrders)
    submitImportedOrders(newOrders) {
      this.isLoading = true;
      this.axios
        .post(`${process.env.VUE_APP_SERVER_URL}/order/bulk`, newOrders)
        .then(() => {
          //eslint-disable-line
          this.loadOrders();
          this.getStockCounts();
          this.$refs.importOrderFile.value = null;
          this.isLoading = false;
        })
        .catch((error) => {
          this.isLoading = false;
          this.handleError(error);
        });
    },

    async exportOrders() {
      try {
        const response = await this.axios.get(`${process.env.VUE_APP_SERVER_URL}/orders`, {
          params: { page: 1, perPage: -1 },
        });
        const allOrders = response.data.orders;
        const newColumns = allOrders.map((item) => ({
          Datum: this.formatDate(item.createdAt),
          Produkt: item.type,
          Serienummer: item.modelnumber,
          IMEI: item.imei_number,
          Programmerad: item.program,
          Lösenord: item.password || '',
        }));
        this.excelExport(newColumns, this.$t('top_titles.stock_document'), this.$t('top_titles.stock_document'));
      } catch (error) {
        this.handleError(error);
      }
    },

    deleteOrderPrompt(order) {
      this.$modal.show("dialog", {
        title: `<span class="text-red-500">${this.$t('modals.delete_order.title', { modelnumber: order.modelnumber })}</span>`,
        buttons: [
          {
            title: `<div class="bg-success-500 text-white text-sm font-sans py-2">${this.$t('modals.cancel')}</div>`,
            handler: () => {
              this.$modal.hide("dialog");
            },
          },
          {
            title: `<div class="bg-red-500 text-white text-sm font-sans py-2">${this.$t('modals.delete')}</div>`,
            handler: () => {
              this.deleteOrder(order._id);
            },
          },
        ],
      });
    },

    async deleteOrder(_id) {
      try {
        // eslint-disable-next-line
        let response = await this.axios.delete(`${process.env.VUE_APP_SERVER_URL}/order/${_id}`);

        this.loadOrders();
        this.getStockCounts();
        this.$modal.hide("dialog");
        this.handleSuccess(this.$t('modals.delete_order.success'));
      } catch (error) {
        this.$modal.hide("dialog");
        this.handleError(error);
      }
    },

    formatDate(date) {
      return this.moment(date).format("YYYY-MM-DD");
    },
  },
  watch: {
    'newOrder.program'(val) {
      const normalized = this.normalizeProgram(val);
      if (normalized !== val) this.newOrder.program = normalized;
    },
  },

  computed: {
    columns() {
      return [
        { label: this.$t("stock_table.date"), field: "createdAt", formatFn: this.formatDate },
        { label: this.$t("stock_table.product"), field: "type", filterOptions: { enabled: true, placeholder: "Produkt", filterDropdownItems: this.devices } },
        { label: this.$t("stock_table.serial_number"), field: "modelnumber" },
        { label: this.$t("stock_table.imei"), field: "imei_number" },
        { label: this.$t("stock_table.programmed"), field: "program" },
        { label: this.$t("stock_table.password"), field: "password" },
        { label: "", field: "delete", sortable: false },
      ];
    },
  },
  created() {
    this.loadOrders();
    this.getStockCounts();
    this.setPageTitle(this.$t("top_titles.stock_document"), "order_document");
  },
};
</script>
